import { EuiButton, EuiFieldText, EuiFlexGrid, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiIcon, EuiPanel, EuiSpacer } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import {ComboPerfilesContainer as ComboPerfiles} from '../../../components/Selectores/Perfiles/container';
import {ComboDireccionesNegocioContainer as ComboDirecciones} from '../../../components/Combos/DireccionesNegocio/container';
import {ComboAreasContainer as ComboAreas} from '../../../components/Combos/Areas/container';
import {ComboValidadoresAS400Container as ComboValidadoresAS400} from '../../../components/Combos/ValidadoresAS400/container';

const DATADEFAULT = {
    dni:'',nombre:'',login:'',perfil:'', idDN:'', area:'', idCP:'', validadorAS400:''
}

const DnPermissions = (permissions) =>{
    return  permissions!==undefined ? [...new Set(permissions.map((f)=> f.idDN))] : permissions;
  }

export const ConfiguracionDatosUsuarioScreen = (props)=>{

    const {data, onSave, isLoading, user} = props;
    
    let [dataInfo, setDataInfo] = useState(DATADEFAULT);

    useEffect(()=>{
        if(data){
            const _dataInfo = {dni:data.dni, nombre:data.nombre, login: data.login, 
                perfil: data.perfil, idDN:data.idDN, area: data.codArea, idCP: data.idCP, validadorAS400:[]}
            
            setDataInfo({..._dataInfo});
        }
    },[data])

    const isInvalidDN = useMemo(() => dataInfo.idDN === undefined || dataInfo.idDN === null || dataInfo.idDN.length === 0,[dataInfo])

    const onChangePerfil = (value) =>{ const _newData = {...dataInfo,...{perfil:value}};setDataInfo(_newData)}
    const onChangeIdDN = (value) =>{ const _newData = {...dataInfo,...{idDN:value}};setDataInfo(_newData)}
    const onChangeArea = (value) =>{ const _newData = {...dataInfo,...{area:value}};setDataInfo(_newData)}
    const onChangeValidador = (value) =>{ const _newData = {...dataInfo,...{validadorAS400:value}};setDataInfo(_newData)}

    const getSelectorEmpleados = ()=> (data && data.administraExpatriados===true) &&(
        <EuiFlexItem>
            <EuiFormRow fullWidth label={<p>Validadores AS400 <span style={{color:'#0b33a9',fontWeight:700}}>(El primer usuario seleccionado, será el validador por defecto)</span></p>}>
                <ComboValidadoresAS400 singleSelection={false} fullWidth 
                selectedOptions={dataInfo.validadorAS400} onChange={value => {onChangeValidador(value)}} initialSelection={data.validadoresAS400.map((m)=> m.validador)}/>
            </EuiFormRow>
        </EuiFlexItem>
    )

    const getIcon = (value)=> (<EuiIcon color={!value?'red':'green'} type={!value? 'cross' : 'check'}/>)

    const onSaveData = () =>{

        let _validadorUpdate = data.validadorAS400;

        if(Array.isArray(dataInfo.validadorAS400))
        {
            _validadorUpdate = dataInfo.validadorAS400.map((v)=> v.value)
            //dataInfo.validadorAS400.length>0 ? dataInfo.validadorAS400[0].value : null;
        }
        
        onSave(_validadorUpdate);
    }

    const getBtnSave = ()=> (data && data.administraExpatriados===true) &&(
        <EuiFlexItem grow={false}>
            <EuiButton fill onClick={()=>{onSaveData()}}>{`Guardar`}</EuiButton> 
        </EuiFlexItem>
    )

    return(
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                <EuiFlexGroup justifyContent='flexEnd'>
                    {getBtnSave()}
                </EuiFlexGroup>
            </EuiFlexItem>

            <EuiFlexItem>
                <EuiPanel>
                   <EuiFlexGrid columns={2}>
                          <EuiFlexItem>
                            <EuiFormRow label={'Dni'} fullWidth>
                                <EuiFieldText readOnly fullWidth value={dataInfo.dni} name="txtDniUserConfig" 
                                isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                         <EuiFlexItem>
                            <EuiFormRow label={'Nombre'} fullWidth>
                                <EuiFieldText readOnly fullWidth value={dataInfo.nombre} name="txtNombreUserConfig" isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow label={'Usuario'} fullWidth>
                                <EuiFieldText readOnly fullWidth value={dataInfo.login} name="txtLoginUserConfig" isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>

                        <EuiFlexItem>
                            <EuiFormRow label={'Perfil'} fullWidth>
                            <ComboPerfiles disabled fullWidth valueOfSelected={dataInfo.perfil} onChange={onChangePerfil}
                            currentUser={user} isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>

                        <EuiFlexItem>
                            <EuiFormRow fullWidth label={'DN/SG'}>
                                <ComboDirecciones fullWidth selectedOptions={dataInfo.idDN} onChange={value=>{onChangeIdDN(value)}} isDisabled={true} isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                        <EuiFormRow fullWidth label={'Area'}>
                            <ComboAreas fullWidth selectedOptions={dataInfo.area} onChange={onChangeArea}
                                idDN={!isInvalidDN ? (Array.isArray(dataInfo.idDN) ? dataInfo.idDN[0].value : dataInfo.idDN) : undefined} 
                                isDisabled={true} dependency isLoading={isLoading}/>
                        </EuiFormRow>
                        </EuiFlexItem>

                        <EuiFlexItem>
                            <EuiFormRow label={'CP'} fullWidth>
                                <EuiFieldText readOnly fullWidth value={dataInfo.idCP} name="txtCPUserConfig" isLoading={isLoading}/>
                            </EuiFormRow>
                        </EuiFlexItem>

                        {getSelectorEmpleados()}
                    </EuiFlexGrid>
                    <EuiSpacer size='m'/>
                    <EuiPanel paddingSize='s'>
                        <EuiFlexItem>
                            <EuiFlexGroup>
                                <EuiFlexItem grow={false}>
                                    <EuiFormRow style={{alignItems:'center'}} label={'Adm. Usuarios'} fullWidth>
                                        {getIcon(data&&data.administraUsuarios)}
                                    </EuiFormRow>   
                                </EuiFlexItem>
                                <EuiFlexItem grow={false}>
                                    <EuiFormRow style={{alignItems:'center'}} label={'Rol Facturación Expatriados'} fullWidth>
                                        {getIcon(data&&(data.administraExpatriados || data.administraExpatriadosLocal || data.consultaExpatriados))}
                                    </EuiFormRow>   
                                </EuiFlexItem>
                            </EuiFlexGroup>
                        </EuiFlexItem>
                    </EuiPanel>
                </EuiPanel>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}